module.exports = __webpack_public_path__ + "static/media/solution-tube-aplusfull-open.9f4de65c.svg";